






















































import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { Vue, Component, Ref } from "vue-property-decorator";
import VehicleItemComponent from "./VehicleItem.vue";

import VehicleFormComponent from "@/components/settings/vehicle/VehicleFormDialog.vue";
import { observeVehicles } from "@/data/repository/VehicleRepository";
import Vehicle from "@/data/models/Vehicle";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { calculateBackgroundStyle, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";

@Component({
  components: {
    "vehicle-item": VehicleItemComponent,
    "vehicle-form": VehicleFormComponent,
  },
})
export default class VehicleManagementComponent extends Vue {
  /** Nothing may be changed while "Sicht auf" is active (ticket 2610051). */
  get isViewAsReadOnly() {
    return isViewAsSelected();
  }

  @Ref("vehicleForm")
  vehicleFormDialog!: VehicleFormComponent;

  vehicles: Vehicle[] = [];
  subscriptions: Array<() => void> = [];
  /**
   * Keeps track of the last‑visited vehicle so that Vue re‑renders
   * when the selection changes.
   */
  lastVisitedKey = "";

  /** Table header background, theme-aware so it stays readable in dark mode. */
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  async onCreateNewVehicle() {
    await this.vehicleFormDialog.show(this.vehicles);
  }

  calculateBackgroundStyle(itemId: string) {
    // Touch the reactive flag so Vue knows to re‑evaluate when it changes
    this.lastVisitedKey;
    return calculateBackgroundStyle(itemId);
  }

  async openVehicleDetails(vehicle: Vehicle) {
    // Persist selection in local storage
    this.lastVisitedKey = `${vehicle.id}`;
    setLastVisitedItem(
      this.lastVisitedKey,
      StorageKeyLastVisitedItemLevel.LEVEL_1
    );

    await this.vehicleFormDialog.show(this.vehicles, vehicle);
  }

  created() {
    this.subscriptions.push(
      observeVehicles((vehicles) => {
        this.vehicles = vehicles;
      })
    );
  }

  mounted() {
    this.setToolbarTitle();
  }

  beforeDestroy() {
    this.subscriptions.forEach(unsub => unsub());
    this.subscriptions = [];
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.vehicleManagement.title").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
